<script lang="ts">
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { HeniEditionsLogo } from '$global/assets/logos/HeniEditionsLogo';
	import { IconLink } from '$global/components/IconLink';
	import { getNavBarContext } from '$global/features/navigation/utils/getNavBarContext/getNavBarContext';

	const { popover } = getNavBarContext();
</script>

<IconLink
	dataCy="header"
	href={GlobalRoutes.EditionsHome}
	label="See HENI Editions home page"
	class="outline-none"
	onclick={() => {
		popover?.states?.open?.set(false);
	}}
>
	<HeniEditionsLogo class="xs:scale-100 origin-left scale-75" />
</IconLink>
